import {
    CustomerTypeResponse
} from '@/modules/configurationModule/detail/accounting/billable/customer-types/services/customer-types.dto'

export type CustomerTypesModalState = CustomerTypeResponse
export const initialCustomerTypesModalState =
    (): CustomerTypeResponse => ({
        id: -1,
        name: '',
        code: '',
        active: true
    })
